/*
THIS COMPONENT IS INCLUDED IN FORM-EDIT REVIEW PAGE
 -----------------------------------------*/
let Reviews = (function () {

    /* private */

    let checkType = () => {
        if ($('input[type=radio][name=type]:checked').val() == 'store') {
            $('.store-type').show();
            $('.product-type').hide();

            return;
        }

        $('.store-type').hide();
        $('.product-type').show();
    }

    let listenTypeChange = () => {
        $('input[type=radio][name=type]').on('change', function() {
            checkType();
        });
    };

    /* public */

    let init = function () {
        checkType();
        listenTypeChange();
    };

    return {
        init: init
    };
})();

export default Reviews;
